import React, { Component } from 'react';
import { matchPath } from 'react-router-dom';
import { Button } from 'carbon-components-react';
import { CardLoader, CommentCard } from '../../../components';
import CommentModal from '../../../components/Modal/CommentModal';
import { getDmService, getByDmService } from '../../../services/Api';

class Comments extends Component {
  constructor(props) {
    super(props);
    
    const { match } = this.props;
    
    const urlPatch = '/pedido/comunicacao/campanha/:id/comentarios';    
    const updatedMatch = matchPath(match.url, {
      path: urlPatch,
    });

    this.orderId = updatedMatch.params.id;

    this.state = {
      data: [],
      isLoading: true,
    };
  }

  componentWillMount() {  
    this.loadComments();
  }

  loadComments = async () => {
    const {updateCount} = this.props;
    try {
      const campaign = await getByDmService('/Pedido/GetCampanhaMensagem', this.orderId);
      const idItem = await campaign.itensCampanhaMensagem[0].id;  
      const data = await getDmService(`Comentario/GetByItemPedido/${idItem}`);
      await updateCount()
      this.setState({ data, isLoading: false, idItem });
    } catch (e) {
      this.setState({ isLoading: false });
      
      console.log(e);
    }
  };

  updateCount = async () => {
    const {updateCount} = this.props;
    await updateCount();
  }

  render() {
    const { data, isLoading, idItem } = this.state;

    if (isLoading) {
      return <CardLoader lines={10} />;
    }

    return (
      <div className="v-md-margin">
        {!data.length ? (
          <div className="empty-comments">Nenhum comentário criado.</div>
        ) : (
          data.map(comment => <CommentCard key={comment.id} comment={comment} />)
        )}

        <Button
          className="bx--btn--full-width v-md-margin"
          onClick={() => this.commentModal.open()}
        >
          Adicionar Comentário
        </Button>

        <CommentModal
          onRef={ref => {
            this.commentModal = ref;
          }}
          orderId={idItem}
          onSave={() => this.loadComments()}
          updateCount={() => this.updateCount()}
        />
      </div>
    );
  }
}

export default Comments;



// WEBPACK FOOTER //
// ./src/screens/client/campaigns/Comments.js